<template>
    <div class="flex flex-col h-screen bg-gray-50 border border-gray-500 rounded-lg shadow-sm">
        <!-- 헤더 -->
        <div class="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-10 py-3">
            <div class="max-w-3xl mx-auto px-4 flex items-center justify-between">
                <div class="flex items-center space-x-2">
                    <button @click="$emit('close')" class="text-gray-400 hover:text-gray-600">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L4.414 9H17a1 1 0 110 2H4.414l5.293 5.293a1 1 0 010 1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                    <h1 class="text-xs sm:text-sm text-gray-700 font-medium">스토어</h1>
                </div>

                <div class="flex items-center space-x-3">
                    <div class="flex space-x-1">
                        <label class="flex items-center cursor-pointer">
                            <input type="checkbox" v-model="inquiryDetail.mr_agabang" disabled class="sr-only peer">
                            <div
                                class="w-4 h-4 border border-gray-300 rounded peer-checked:bg-blue-500 peer-checked:border-blue-500">
                            </div>
                            <span class="text-[10px] sm:text-xs text-gray-600">아가방</span>
                        </label>
                        <!-- 모달 -->
                        <div class="fixed inset-0 z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                            <!-- 배경 오버레이 -->
                            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                            <!-- 모달 컨테이너 -->
                            <div class="fixed inset-0 overflow-hidden">
                                <div class="absolute inset-0">
                                    <div class="h-full w-full bg-white">
                                        <!-- 헤더 -->
                                        <div class="fixed top-0 left-0 right-0 z-10 bg-white border-b border-gray-200">
                                            <div class="max-w-3xl mx-auto">
                                                <!-- 제목 및 닫기 버튼 -->
                                                <div class="flex items-center justify-between px-4 py-2">
                                                    <div class="flex items-center gap-3 min-w-0 flex-1">
                                                        <button @click="$emit('close')"
                                                            class="text-gray-500 hover:text-gray-700 flex-shrink-0">
                                                            <svg class="w-5 h-5" fill="none" stroke="currentColor"
                                                                viewBox="0 0 24 24">
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                                            </svg>
                                                        </button>
                                                        <h2 class="text-xs sm:text-sm font-medium break-words pr-2">
                                                            {{ inquiryDetail.title }}</h2>
                                                    </div>
                                                    <div class="flex-shrink-0">
                                                        <span :class="[
                                                            'px-2 py-0.5 text-xs rounded-full whitespace-nowrap',
                                                            inquiryDetail.status_text === '안읽음' ? 'bg-gray-100 text-gray-600' :
                                                                inquiryDetail.status_text === '읽음' ? 'bg-blue-100 text-blue-800' :
                                                                    'bg-green-100 text-green-800'
                                                        ]">
                                                            {{ inquiryDetail.status_text }}
                                                        </span>
                                                    </div>
                                                </div>



                                                <!-- 브랜드, 카테고리, 작성일 -->
                                                <div
                                                    class="px-4 py-2 border-t border-gray-100 flex flex-wrap items-center gap-2 text-[11px] sm:text-xs text-gray-600">
                                                    <!-- 브랜드 선택 -->
                                                    <div class="flex items-center gap-2 flex-shrink-0">
                                                        <label class="flex items-center gap-1">
                                                            <input type="checkbox" :checked="inquiryDetail.mr_agabang"
                                                                disabled
                                                                class="w-3.5 h-3.5 text-pink-600 rounded border-gray-300">
                                                            <span>아가방</span>
                                                        </label>
                                                        <label class="flex items-center gap-1">
                                                            <input type="checkbox" :checked="inquiryDetail.mr_ettoi"
                                                                disabled
                                                                class="w-3.5 h-3.5 text-purple-600 rounded border-gray-300">
                                                            <span>에뜨와</span>
                                                        </label>
                                                        <label class="flex items-center gap-1">
                                                            <input type="checkbox" :checked="inquiryDetail.mr_disney"
                                                                disabled
                                                                class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300">
                                                            <span>디즈니</span>
                                                        </label>
                                                    </div>

                                                    <span class="text-gray-300">|</span>

                                                    <!-- 카테고리 -->
                                                    <div class="flex items-center gap-1 flex-shrink-0">
                                                        <span>{{ inquiryDetail.cat_name }}</span>
                                                        <span class="text-gray-400">&gt;</span>
                                                        <span>{{ inquiryDetail.midcat_name }}</span>
                                                        <template
                                                            v-if="inquiryDetail.midcat_name !== inquiryDetail.subcat_name">
                                                            <span class="text-gray-400">&gt;</span>
                                                            <span>{{ inquiryDetail.subcat_name }}</span>
                                                        </template>
                                                    </div>

                                                    <span class="text-gray-300">|</span>

                                                    <!-- 작성일 -->
                                                    <div class="flex items-center gap-1 flex-shrink-0">
                                                        <svg class="w-3.5 h-3.5 text-gray-400" fill="none"
                                                            stroke="currentColor" viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                        </svg>
                                                        <span>{{ formatDate(inquiryDetail.reg_date, false) }}</span>
                                                    </div>
                                                </div>
                                                <!-- 상담 종료 표시 -->
                                                <div v-if="inquiryDetail.status == 128"
                                                    class="flex justify-start  border-t border-gray-100">
                                                    <div
                                                        class="bg-[#F2F2F2] px-4 py-1.5 text-xs text-[#999999] flex items-center justify-between w-full">
                                                        <div class="flex items-center gap-1.5">
                                                            <svg class="w-1.5 h-1.5" viewBox="0 0 6 6"
                                                                fill="currentColor">
                                                                <circle cx="3" cy="3" r="3" />
                                                            </svg>
                                                            상담이 종료되었습니다
                                                        </div>
                                                        <span v-if="completedDate" class="text-[11px]">{{
                                                            formatDate(completedDate, false) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- 메인 컨텐츠 -->
                                        <div :style="{ paddingTop: `${contentPadding}px` }"
                                            class="h-screen pb-[180px] overflow-y-auto bg-[#fbfbfc]">
                                            <div class="max-w-3xl mx-auto">
                                                <!-- 채팅형 메시지 -->
                                                <div class="space-y-4 px-4" ref="messageContainer">
                                                    <!-- 문의 내용 (오른쪽) -->
                                                    <div class="flex flex-col items-end">
                                                        <div class="flex items-start gap-1 flex-row-reverse">
                                                            <div
                                                                class="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 border border-gray-200">
                                                                <span class="text-sm font-medium text-gray-600">나</span>
                                                            </div>
                                                            <div
                                                                class="bg-white border border-gray-200 text-gray-800 rounded-2xl px-4 py-2.5 shadow-sm max-w-[75%]">
                                                                <p
                                                                    class="text-[10px] sm:text-xs whitespace-pre-wrap break-words overflow-hidden">
                                                                    {{
                                                                        inquiryDetail.content }}</p>
                                                                <!-- 첨부파일 -->
                                                                <div v-if="inquiryDetail.attachments?.length > 0"
                                                                    class="mt-2 pt-2 border-t border-blue-400">
                                                                    <div class="flex flex-col gap-2">
                                                                        <div class="text-xs text-gray-500 mb-1">
                                                                            첨부파일 ({{ inquiryDetail.attachments.length
                                                                            }}개)
                                                                        </div>
                                                                        <div v-for="(file, index) in inquiryDetail.attachments"
                                                                            :key="index" class="relative group">
                                                                            <!-- 이미지 파일인 경우 -->
                                                                            <template
                                                                                v-if="isImageFile(file.name) && !isImageLoadFailed(file)">
                                                                                <div class="relative group">
                                                                                    <div class="aspect-w-4 aspect-h-3 bg-gray-100 rounded-lg overflow-hidden cursor-pointer max-w-[300px]"
                                                                                        @click.prevent="openImagePreview(file)">
                                                                                        <img :src="getImageUrl(file)"
                                                                                            :alt="file.name"
                                                                                            loading="lazy"
                                                                                            class="w-full h-full object-contain rounded-lg" />
                                                                                        <div
                                                                                            class="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity flex items-center justify-center rounded-lg">
                                                                                            <svg class="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                                                                                                fill="none"
                                                                                                stroke="currentColor"
                                                                                                viewBox="0 0 24 24">
                                                                                                <path
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                    stroke-width="2"
                                                                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                                                                            </svg>
                                                                                        </div>
                                                                                    </div>
                                                                                    <!-- 파일 정보 표시 -->
                                                                                    <div
                                                                                        class="mt-1 text-xs text-gray-500">
                                                                                        <span
                                                                                            class="truncate block max-w-[300px]">{{
                                                                                                file.name }}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            <!-- 이미지가 아닌 경우 -->
                                                                            <template v-else>
                                                                                <div>
                                                                                    <a @click.prevent="handleFileClick(file)"
                                                                                        class="flex items-center gap-2 text-xs text-blue-600 hover:text-blue-700 cursor-pointer">
                                                                                        <svg class="w-3.5 h-3.5 flex-shrink-0"
                                                                                            fill="none"
                                                                                            stroke="currentColor"
                                                                                            viewBox="0 0 24 24">
                                                                                            <path stroke-linecap="round"
                                                                                                stroke-linejoin="round"
                                                                                                stroke-width="2"
                                                                                                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                                                                        </svg>
                                                                                        <span
                                                                                            class="truncate max-w-[150px]">{{
                                                                                                file.name }}</span>
                                                                                    </a>
                                                                                </div>
                                                                            </template>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mt-1 flex items-center gap-2 mr-10">
                                                            <span class="text-[11px] text-gray-500">{{
                                                                formatDate(inquiryDetail.reg_date, false) }}</span>
                                                            <div class="flex items-center gap-1">
                                                                <button @click="handleDelete"
                                                                    class="text-[11px] text-red-600 hover:text-red-700">
                                                                    삭제
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- 댓글 목록 -->
                                                <div v-for="(comment, index) in comments" :key="comment.id"
                                                    class="mt-3">
                                                    <!-- 상담 종료 표시 -->
                                                    <div v-if="shouldShowCompletionMessage(index)"
                                                        class="flex justify-center mb-4">
                                                        <div
                                                            class="bg-gray-100 rounded-full px-4 py-1.5 text-xs text-gray-600">
                                                            상담이 종료되었습니다
                                                        </div>
                                                    </div>

                                                    <div
                                                        :class="{ 'flex flex-col items-end': !comment.admin_id, 'flex flex-col items-start ml-2 sm:ml-0': comment.admin_id }">
                                                        <div class="flex flex-col"
                                                            :class="{ 'items-end': !comment.admin_id, 'items-start': comment.admin_id }">
                                                            <!-- 메시지와 프로필 -->
                                                            <div class="flex items-start gap-1"
                                                                :class="{ 'flex-row-reverse': !comment.admin_id, 'flex-row': comment.admin_id }">
                                                                <div :class="[
                                                                    'rounded-full flex items-center justify-center flex-shrink-0 border border-gray-200',
                                                                    comment.admin_id ? 'w-8 h-8 bg-[#374151]' : 'w-8 h-8  bg-white'
                                                                ]">
                                                                    <span :class="[
                                                                        comment.admin_id ? 'text-[9px] sm:text-[10px] font-bold max-w-[40px] text-white' : 'text-sm font-medium text-gray-600',
                                                                        'truncate text-center'
                                                                    ]">
                                                                        {{ comment.admin_id ? comment.admin_name :
                                                                            '나' }}
                                                                    </span>
                                                                </div>
                                                                <div :class="[
                                                                    'rounded-2xl px-4 py-2.5 shadow-sm max-w-[75%]',
                                                                    comment.admin_id
                                                                        ? 'bg-[#d1d5db] text-gray-800'
                                                                        : 'bg-white border border-gray-200 text-gray-800'
                                                                ]">
                                                                    <p
                                                                        class="text-[10px] sm:text-xs whitespace-pre-wrap break-words overflow-hidden">
                                                                        {{ comment.content }}
                                                                    </p>
                                                                    <!-- 첨부파일 -->
                                                                    <div v-if="comment.attachments?.length > 0"
                                                                        :class="['mt-2 pt-2 border-t', comment.admin_id ? 'border-gray-200' : 'border-blue-400']">
                                                                        <div class="flex flex-col gap-1">
                                                                            <div class="text-xs text-gray-500 mb-1">
                                                                                첨부파일 ({{ comment.attachments.length
                                                                                }}개)
                                                                            </div>
                                                                            <div v-for="(file, index) in comment.attachments"
                                                                                :key="index">
                                                                                <!-- 이미지 파일인 경우 -->
                                                                                <template
                                                                                    v-if="isImageFile(file.name) && !isImageLoadFailed(file)">
                                                                                    <div class="relative group">
                                                                                        <div class="aspect-w-4 aspect-h-3 bg-gray-100 rounded-lg overflow-hidden cursor-pointer max-w-[300px]"
                                                                                            @click.prevent="openImagePreview(file)">
                                                                                            <img :src="getImageUrl(file)"
                                                                                                :alt="file.name"
                                                                                                loading="lazy"
                                                                                                class="w-full h-full object-contain rounded-lg" />
                                                                                            <div
                                                                                                class="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity flex items-center justify-center rounded-lg">
                                                                                                <svg class="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    viewBox="0 0 24 24">
                                                                                                    <path
                                                                                                        stroke-linecap="round"
                                                                                                        stroke-linejoin="round"
                                                                                                        stroke-width="2"
                                                                                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                                                                                </svg>
                                                                                            </div>
                                                                                        </div>
                                                                                        <!-- 파일 정보 표시 -->
                                                                                        <div
                                                                                            class="mt-1 text-xs text-gray-500">
                                                                                            <span
                                                                                                class="truncate block max-w-[300px]">{{
                                                                                                    file.name }}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </template>
                                                                                <!-- 이미지가 아닌 경우 -->
                                                                                <template v-else>
                                                                                    <div>
                                                                                        <a @click.prevent="handleFileClick(file)"
                                                                                            class="flex items-center gap-2 text-xs text-blue-600 hover:text-blue-700 cursor-pointer">
                                                                                            <svg class="w-3.5 h-3.5 flex-shrink-0"
                                                                                                fill="none"
                                                                                                stroke="currentColor"
                                                                                                viewBox="0 0 24 24">
                                                                                                <path
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                    stroke-width="2"
                                                                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                                                                            </svg>
                                                                                            <span
                                                                                                class="truncate max-w-[150px]">{{
                                                                                                    file.name
                                                                                                }}</span></a>
                                                                                    </div>
                                                                                </template>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- 시간과 상태 -->
                                                            <div class="mt-1"
                                                                :class="{ 'ml-14': comment.admin_id, 'mr-10': !comment.admin_id }">
                                                                <div class="flex items-center gap-2">
                                                                    <span class="text-[11px] text-gray-500">{{
                                                                        formatDate(comment.reg_date, false) }}</span>
                                                                    <template v-if="comment.admin_id">
                                                                        <span
                                                                            class="text-[10px] px-1.5 py-0.5 bg-[#e2e8f0] text-gray-500 rounded-full">
                                                                            본사
                                                                        </span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-if="comment.status === 125"
                                                                            class="px-1.5 py-0.5 text-[10px] rounded-full bg-gray-100 text-gray-600">
                                                                            안읽음
                                                                        </span>
                                                                        <button @click="handleDeleteComment(comment.id)"
                                                                            class="text-[11px] text-red-600 hover:text-red-700">
                                                                            삭제
                                                                        </button>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 답변 입력 영역 -->
                                <div class="fixed bottom-0 left-0 right-0 z-10 bg-white border-t border-gray-200">
                                    <div class="max-w-3xl mx-auto px-4 py-3">
                                        <div class="flex flex-col gap-2">
                                            <textarea v-model="newComment" rows="3" placeholder="답변을 입력하세요"
                                                class="w-full px-3 py-2 text-[10px] sm:text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>

                                            <div class="flex items-center justify-between">
                                                <div class="flex-1">
                                                    <input type="file" ref="fileInput" @change="handleFileChange"
                                                        multiple
                                                        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                                                        class="hidden" />
                                                    <div v-if="selectedFiles.length > 0"
                                                        class="flex flex-wrap gap-2 mb-2">
                                                        <div v-for="(file, index) in selectedFiles" :key="index"
                                                            class="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded text-xs">
                                                            <span class="truncate max-w-[200px]">{{ file.name }}</span>
                                                            <button @click="removeFile(index)"
                                                                class="text-gray-500 hover:text-gray-700">
                                                                <svg class="w-3.5 h-3.5" fill="none"
                                                                    stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <button @click="$refs.fileInput.click()"
                                                        class="text-xs sm:text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1">
                                                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor"
                                                            viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                                                        </svg>
                                                        <span>파일 첨부(3개까지 가능합니다)</span>
                                                    </button>
                                                </div>
                                                <button @click="submitComment"
                                                    class="px-3 py-1.5 text-[10px] sm:text-xs bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors">
                                                    답변 등록
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 상담 종료 표시 -->
        <div v-if="inquiryDetail.status == 128" class="flex justify-center mt-2">
            <div class="bg-gray-100 rounded-full px-4 py-1.5 text-xs text-gray-600">
                상담이 종료되었습니다
            </div>
        </div>
        <!-- 이미지 미리보기 모달 -->
        <div v-if="showImagePreview" class="fixed inset-0 z-50 flex flex-col bg-black bg-opacity-75">
            <!-- 상단 버튼 영역 -->
            <div
                class="sticky top-0 z-10 flex items-center justify-end gap-2 p-4 bg-gradient-to-b from-black/50 to-transparent">
                <button @click.stop="zoomIn"
                    class="text-white hover:text-gray-300 bg-gray-600 hover:bg-gray-700 rounded-lg px-3 py-1.5 text-[10px] sm:text-xs flex items-center gap-1">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    <span>확대</span>
                </button>
                <button @click.stop="zoomOut"
                    class="text-white hover:text-gray-300 bg-gray-600 hover:bg-gray-700 rounded-lg px-3 py-1.5 text-[10px] sm:text-xs flex items-center gap-1">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                    </svg>
                    <span>축소</span>
                </button>
                <button @click.stop="downloadPreviewImage"
                    class="text-white hover:text-gray-300 bg-blue-500 hover:bg-blue-600 rounded-lg px-3 py-1.5 text-sm flex items-center gap-1">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                    <span>다운로드</span>
                </button>
                <button @click.stop="closeImagePreview" class="text-white hover:text-gray-300">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <!-- 이미지 영역 -->
            <div class="flex-1 overflow-hidden p-4">
                <div class="min-h-full flex items-center justify-center">
                    <!-- 로딩 스피너 -->
                    <div v-if="isImageLoading" class="flex items-center justify-center">
                        <span class="text-white text-sm">이미지를 불러오는 중...</span>
                    </div>
                    <!-- 이미지 -->
                    <div class="overflow-auto max-h-[calc(100vh-120px)] w-full flex items-start justify-center">
                        <img v-show="!isImageLoading" :src="previewImageUrl" alt="Preview"
                            :style="{ transform: `scale(${zoomLevel})`, transformOrigin: 'top center' }"
                            class="max-w-full w-auto h-auto object-contain transition-transform duration-200"
                            @load="handleImageLoad" @error="handleImageError" @click.stop="toggleZoom" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, nextTick } from 'vue';
import inquiryAPI from '@/api/inquiry/inquiry';
import Swal from 'sweetalert2';

const props = defineProps({
    inquiry: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['close', 'submit-comment', 'delete', 'refresh-list']);

const inquiryDetail = ref({});
const comments = ref([]);
const completedDate = ref(null);
const newComment = ref('');
const messageContainer = ref(null);
const fileInput = ref(null);
const selectedFiles = ref([]);
const showImagePreview = ref(false);
const previewImageUrl = ref('');
const failedImages = ref(new Set());
const currentPreviewFile = ref(null);
const contentPadding = ref(130); // 기본 패딩값
const isImageLoading = ref(true);
const zoomLevel = ref(1);
const isZoomed = ref(false);
let observer = null;

// 상단 메뉴 높이 측정 함수
const updateContentPadding = async () => {
    await nextTick();
    const headerElement = document.querySelector('.fixed.top-0');
    if (headerElement) {
        const headerHeight = headerElement.offsetHeight;
        contentPadding.value = headerHeight + 20; // 여유 공간 20px 추가
    }
};

// 리사이즈 이벤트 처리
onMounted(async () => {
    // 초기 업데이트
    await updateContentPadding();
    
    // DOM 변화 감지를 위한 MutationObserver 설정
    const headerElement = document.querySelector('.fixed.top-0');
    if (headerElement) {
        observer = new MutationObserver(updateContentPadding);
        observer.observe(headerElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }
    
    // 리사이즈 이벤트 리스너 등록
    window.addEventListener('resize', updateContentPadding);
    
    // 추가적인 업데이트 시도
    setTimeout(updateContentPadding, 100);
    setTimeout(updateContentPadding, 500);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateContentPadding);
    if (observer) {
        observer.disconnect();
    }
});

const loadInquiryDetail = async () => {
    try {
        const [detailResponse, commentsResponse] = await Promise.all([
            inquiryAPI.getInquiryDetail(props.inquiry.id),
            inquiryAPI.getInquiryComments(props.inquiry.id)
        ]);
        
        inquiryDetail.value = detailResponse.data;
        await updateContentPadding();
        
        // status가 128(종료)인 경우에만 종료 날짜 조회
        if (inquiryDetail.value.status == 128) {
            const historyResponse = await inquiryAPI.getCompletedDate(props.inquiry.id);
            completedDate.value = historyResponse.data.reg_date;
            
            // 종료 시점 이후의 댓글은 completed 속성을 true로 설정
            // commentsResponse.data.forEach(comment => {
            //     comment.completed = new Date(comment.reg_date) > new Date(completedDate.value);
            // });
        }
        
        // 댓글 처리 및 정렬
        comments.value = commentsResponse.data
            .filter(comment => comment.id !== inquiryDetail.value.id)
            .sort((a, b) => new Date(a.reg_date) - new Date(b.reg_date));
            
        // 문의 내용 첨부파일이 있을 때만 로깅
        if (inquiryDetail.value.attachments?.length > 0) {
            console.log('문의 내용 첨부파일:', inquiryDetail.value.attachments.map(file => ({
                name: file.name,
                is_new: file.is_new,
                type: file.type,
                file_name: file.file_name,
                url: file.url,
                thumbnailUrl: file.thumbnailUrl,
                fullPath: file.is_new ? file.thumbnailUrl : `https://work-api.agabang.com:6300/images/req/${file.type === 'cmt' ? 'cmt/' : ''}${file.file_name}`
            })));
            
            // 이미지 프리로딩
            preloadImages(inquiryDetail.value.attachments);
        }
        
        // 댓글 첨부파일이 있는 경우만 로깅
        const commentsWithAttachments = comments.value.filter(comment => comment.attachments?.length > 0);
        if (commentsWithAttachments.length > 0) {
            console.log('댓글 첨부파일:', commentsWithAttachments.map(comment => ({
                commentId: comment.id,
                attachments: comment.attachments.map(file => ({
                    name: file.name,
                    is_new: file.is_new,
                    type: file.type,
                    file_name: file.file_name,
                    url: file.url,
                    thumbnailUrl: file.thumbnailUrl,
                    fullPath: file.is_new ? file.thumbnailUrl : `https://work-api.agabang.com:6300/images/req/${file.type === 'cmt' ? 'cmt/' : ''}${file.file_name}`
                }))
            })));
            
            // 댓글 이미지 프리로딩
            commentsWithAttachments.forEach(comment => {
                preloadImages(comment.attachments);
            });
        }
            
        scrollToBottom();
    } catch (error) {
        console.error('문의 상세 조회 실패:', error);
    }
};

const scrollToBottom = () => {
    setTimeout(() => {
        if (messageContainer.value) {
            messageContainer.value.scrollTop = messageContainer.value.scrollHeight;
        }
    }, 100);
};

const formatDate = (dateString, includeYear = false) => {
    if (!dateString) return '-';
    
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';
        
        return new Intl.DateTimeFormat('ko-KR', {
            year: includeYear ? 'numeric' : undefined,
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    } catch (error) {
        console.error('날짜 포맷팅 에러:', error);
        return '-';
    }
};

const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    
    // 파일 개수 제한 체크
    if (selectedFiles.value.length + files.length > 3) {
        alert('파일은 최대 3개까지만 첨부할 수 있습니다.');
        event.target.value = '';
        return;
    }
    
    // 파일 검증
    for (const file of files) {
        if (!file.type.startsWith('image/') && file.type !== 'image/webp') {
            alert('이미지 파일만 업로드할 수 있습니다.');
            event.target.value = '';
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            alert('파일 크기는 10MB를 초과할 수 없습니다.');
            event.target.value = '';
            return;
        }
    }
    
    selectedFiles.value.push(...files);
    event.target.value = '';
};

const removeFile = (index) => {
    selectedFiles.value.splice(index, 1);
};

// 이미지 압축 함수 추가
const compressImage = (file, isThumbnail = false) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // 썸네일인 경우 더 작은 크기로 압축
                let width = img.width;
                let height = img.height;
                if (isThumbnail) {
                    // 썸네일은 최대 300x300 크기로
                    if (width > 300) {
                        height = Math.round((height * 300) / width);
                        width = 300;
                    }
                    if (height > 300) {
                        width = Math.round((width * 300) / height);
                        height = 300;
                    }
                } else {
                    // 원본은 최대 1920x1080 크기로
                    if (width > 1920) {
                        height = Math.round((height * 1920) / width);
                        width = 1920;
                    }
                    if (height > 1080) {
                        width = Math.round((width * 1080) / height);
                        height = 1080;
                    }
                }

                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);

                // 압축된 이미지를 Blob으로 변환
                canvas.toBlob(
                    (blob) => {
                        resolve(new File([blob], file.name, {
                            type: 'image/png',
                            lastModified: Date.now(),
                        }));
                    },
                    'image/png',
                    isThumbnail ? 0.2 : 0.4 // 썸네일은 0.2, 원본은 0.4로 압축률 증가
                );
            };
        };
    });
};

const submitComment = async () => {
    if (!newComment.value.trim()) return;

    const formData = new FormData();
    formData.append('comment', newComment.value);
    formData.append('completed', inquiryDetail.value.status == 128);
    formData.append('upload_year', new Date().getFullYear().toString());
    
    // 첨부파일 추가
    for (const file of selectedFiles.value) {
        const originalFile = await compressImage(file, false);
        const thumbnailFile = await compressImage(file, true);
        formData.append('files', originalFile);
        formData.append('thumbnails', thumbnailFile);
    }

    try {
        // 답변 등록 API 직접 호출
        await inquiryAPI.addComment(props.inquiry.id, formData);
        
        // 성공 메시지 표시
        await Swal.fire({
            title: '등록 완료',
            text: '답변이 등록되었습니다.',
            icon: 'success',
            confirmButtonColor: '#3085d6'
        });

        // 상세 조회 새로고침
        await loadInquiryDetail();
        
        // 입력 필드 초기화
        newComment.value = '';
        selectedFiles.value = [];
    } catch (error) {
        console.error('답변 등록 실패:', error);
        await Swal.fire({
            title: '오류',
            text: '답변 등록에 실패했습니다.',
            icon: 'error',
            confirmButtonColor: '#3085d6'
        });
    }
};

// 상담 종료 메시지를 표시해야 하는지 확인하는 함수
const shouldShowCompletionMessage = (index) => {
    if (index === 0) return false;
    
    const currentComment = comments.value[index];
    const previousComment = comments.value[index - 1];
    
    // 이전 댓글이 completed가 false이고 현재 댓글이 completed가 true인 경우에만 표시
    return !previousComment.completed && currentComment.completed;
};

// 이미지 파일인지 확인하는 함수
const isImageFile = (filename) => {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
    return imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
};

// 이미지 프리로딩 함수
const preloadImages = (files) => {
    files.forEach(file => {
        if (isImageFile(file.name)) {
            const img = new Image();
            const imageUrl = file.is_new ? file.thumbnailUrl : `https://work-api.agabang.com:6300/images/req/${file.type === 'cmt' ? 'cmt/' : ''}${file.file_name}`;
            img.src = imageUrl;
            img.onerror = () => {
                failedImages.value.add(imageUrl);
            };
        }
    });
};

// 이미지 로딩 실패 여부 확인 함수
const isImageLoadFailed = (file) => {
    const imageUrl = file.is_new ? file.thumbnailUrl : `https://work-api.agabang.com:6300/images/req/${file.type === 'cmt' ? 'cmt/' : ''}${file.file_name}`;
    return failedImages.value.has(imageUrl);
};

// 다운로드 URL 생성 함수
const getDownloadUrl = (file) => {
    if (file.is_new) {
        return file.url || file.thumbnailUrl; // 원본 URL 우선 사용
    }
    const baseUrl = "https://work-api.agabang.com:6300/images/req";
    return file.type === 'cmt' ? `${baseUrl}/cmt/${file.file_name}` : `${baseUrl}/${file.file_name}`;
};

const getImageUrl = (file) => {
    if (file.is_new) {
        return file.thumbnailUrl || file.url; // 썸네일 우선 사용 (목록에서는 썸네일)
    }
    const baseUrl = "https://work-api.agabang.com:6300/images/req";
    return file.type === 'cmt' ? `${baseUrl}/cmt/${file.file_name}` : `${baseUrl}/${file.file_name}`;
};

const handleFileClick = async (file) => {
    if (!isImageFile(file.name)) {
        // 이미지가 아닌 경우만 바로 다운로드
        downloadAttachment(file);
        return;
    }
    
    // 이미지인 경우 미리보기
    currentPreviewFile.value = file;
    previewImageUrl.value = getDownloadUrl(file);
    showImagePreview.value = true;
};

const downloadAttachment = async (file) => {
    try {
        if (!file?.name) return;

        // 백엔드 API를 통해 파일 다운로드
        const response = await inquiryAPI.downloadFile(file.file_name, file.type || 'req');
        
        // Content-Type 확인 및 기본값 설정
        let contentType = response.headers['content-type'];
        
        // Content-Type이 없거나 잘못된 경우, 파일 확장자를 기반으로 MIME 타입 추정
        if (!contentType || contentType === 'application/octet-stream') {
            const ext = file.name.split('.').pop().toLowerCase();
            const mimeTypes = {
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'png': 'image/png',
                'gif': 'image/gif',
                'webp': 'image/webp'
            };
            contentType = mimeTypes[ext] || 'application/octet-stream';
        }

        // ArrayBuffer를 Blob으로 변환
        const blob = new Blob([response.data], { type: contentType });
        
        // Blob URL 생성 및 다운로드
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error('파일 다운로드 중 오류:', error, {
            fileName: file.name,
            fileType: file.type,
            responseHeaders: error.response?.headers
        });
    }
};

const handleImageLoad = () => {
    isImageLoading.value = false;
};

const handleImageError = () => {
    isImageLoading.value = false;
    alert('이미지를 불러오는데 실패했습니다.');
    closeImagePreview();
};

const openImagePreview = (file) => {
    showImagePreview.value = true;
    isImageLoading.value = true;
    currentPreviewFile.value = file;
    
    // nextTick을 사용하여 모달이 먼저 렌더링된 후 이미지 로드
    nextTick(() => {
        previewImageUrl.value = getDownloadUrl(file);
    });
};

const closeImagePreview = () => {
    showImagePreview.value = false;
    previewImageUrl.value = '';
    currentPreviewFile.value = null;
    isImageLoading.value = true;
    zoomLevel.value = 1;
    isZoomed.value = false;
};

const handleDelete = async () => {
    try {
        const result = await Swal.fire({
            title: '문의를 삭제하시겠습니까?',
            text: '삭제된 문의는 복구할 수 없습니다.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '삭제',
            cancelButtonText: '취소',
        });

        if (result.isConfirmed) {
            await inquiryAPI.deleteInquiry(props.inquiry.id);
            await Swal.fire({
                title: '삭제 완료',
                text: '문의가 삭제되었습니다.',
                icon: 'success',
                confirmButtonText: '확인',
            });
            emit('refresh-list');
            emit('close');
        }
    } catch (error) {
        console.error('문의 삭제 실패:', error);
        Swal.fire({
            title: '오류',
            text: '문의 삭제에 실패했습니다.',
            icon: 'error',
            confirmButtonText: '확인',
        });
    }
};

// 댓글 삭제 처리
const handleDeleteComment = async (commentId) => {
    try {
        const result = await Swal.fire({
            title: '댓글을 삭제하시겠습니까?',
            text: '삭제된 댓글은 복구할 수 없습니다.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '삭제',
            cancelButtonText: '취소',
        })

        if (result.isConfirmed) {
            await inquiryAPI.deleteComment(props.inquiry.id, commentId)
            await Swal.fire({
                title: '삭제 완료',
                text: '댓글이 삭제되었습니다.',
                icon: 'success',
                confirmButtonColor: '#3085d6',
            })
            // 댓글 목록 새로고침
            await loadInquiryDetail()
        }
    } catch (error) {
        console.error('댓글 삭제 중 오류:', error)
        await Swal.fire({
            title: '오류',
            text: '댓글 삭제에 실패했습니다.',
            icon: 'error',
            confirmButtonColor: '#3085d6',
        })
    }
}

const zoomIn = () => {
    if (zoomLevel.value < 5) {
        zoomLevel.value += 0.5;
    }
};

const zoomOut = () => {
    if (zoomLevel.value > 0.5) {
        zoomLevel.value -= 0.5;
    }
};

const toggleZoom = () => {
    if (isZoomed.value) {
        zoomLevel.value = 1;
    } else {
        zoomLevel.value = 3;
    }
    isZoomed.value = !isZoomed.value;
};

const downloadPreviewImage = async () => {
    if (!currentPreviewFile.value) return;

    try {
        const file = currentPreviewFile.value;
        
        if (file.is_new) {
            // S3 파일인 경우 API를 통해 다운로드
            const response = await inquiryAPI.downloadS3File(file.file_name, file.upload_year);
            
            // Content-Type 확인 및 기본값 설정
            let contentType = response.headers['content-type'];
            
            // Content-Type이 없거나 잘못된 경우, 파일 확장자를 기반으로 MIME 타입 추정
            if (!contentType || contentType === 'application/octet-stream') {
                const ext = file.name.split('.').pop().toLowerCase();
                const mimeTypes = {
                    // 이미지 파일
                    'jpg': 'image/jpeg',
                    'jpeg': 'image/jpeg',
                    'png': 'image/png',
                    'gif': 'image/gif',
                    'webp': 'image/webp',
                    // 문서 파일
                    'pdf': 'application/pdf',
                    'doc': 'application/msword',
                    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'xls': 'application/vnd.ms-excel',
                    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'ppt': 'application/vnd.ms-powerpoint',
                    'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                    // 기타 파일
                    'txt': 'text/plain',
                    'csv': 'text/csv',
                    'zip': 'application/zip',
                    'rar': 'application/x-rar-compressed'
                };
                contentType = mimeTypes[ext] || 'application/octet-stream';
            }

            // ArrayBuffer를 Blob으로 변환
            const blob = new Blob([response.data], { type: contentType });
            
            // Blob URL 생성 및 다운로드
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = file.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } else {
            // 기존 파일인 경우 work-api URL 직접 사용
            const defaultUrl = "https://work-api.agabang.com:6300";
            const url = file.type === 'cmt' 
                ? `${defaultUrl}/api/request_management/downloadCmt?file_name=${file.file_name}`
                : `${defaultUrl}/api/request_management/download?file_name=${file.file_name}`;
            
            // 다운로드 링크 생성 및 클릭
            const link = document.createElement('a');
            link.href = url;
            link.download = file.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    } catch (error) {
        console.error('이미지 다운로드 중 오류:', error);
        Swal.fire({
            title: '오류',
            text: '이미지 다운로드에 실패했습니다.',
            icon: 'error',
            confirmButtonColor: '#3085d6'
        });
    }
};

watch(() => props.inquiry.id, () => {
    loadInquiryDetail();
}, { immediate: true });
</script>

<style scoped>
.comment-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
}

.delete-btn {
    padding: 4px 8px;
    background-color: #ff4444;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.delete-btn:hover {
    background-color: #cc0000;
}
</style>
